import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {StockLevelOverwrite} from '../types'

import {stockOverwritesQueryOptions, StockOverwritesQueryKey} from './stockOverwritesQueryOptions'

export {StockOverwritesQueryKey}

type Params<TReturn = StockLevelOverwrite[]> = {
  plantCode: string
  materialId: number
  from: string
  to: string
  options?: Omit<
    UseQueryOptions<StockLevelOverwrite[], AxiosError, TReturn>,
    'queryKey' | 'queryFn'
  >
}

export const useStockOverwrites = <TReturn = StockLevelOverwrite[]>({
  plantCode,
  materialId,
  from,
  to,
  options
}: Params<TReturn>) =>
  useQuery<StockLevelOverwrite[], AxiosError, TReturn>({
    ...stockOverwritesQueryOptions(plantCode, materialId, from, to),
    ...options
  })
